import { convertArrayOfObjectToHashTable } from '@/utils/arrayToHashTable';

function convertMatchingTypes(matchingTypes) {
  return convertArrayOfObjectToHashTable(
    matchingTypes,
    ({ property }) => property,
  );
}

export default function translateMatchingType(matchingTypes) {
  const matchingTypeByProperty = convertMatchingTypes(matchingTypes);

  return matchType => {
    if (matchType in matchingTypeByProperty) {
      return matchingTypeByProperty[matchType].label;
    }

    return '';
  };
}
